import { useTranslation } from "react-i18next";

import { usePlatformCounters } from "@/hooks/usePlatformCounters";
import { formatCount } from "../../../shared/platformCounters";

/**
 * The text next to the hero's stars.
 *
 * With live counters it says how many firms registered and how many people
 * use Bidmio, rounded down by the ERP and written with a `+`, so it is never
 * more than the truth. Without them it keeps the line the hero always had.
 */
export const HeroTrustLine = () => {
  const { t, i18n } = useTranslation();
  const counters = usePlatformCounters();
  const lang = i18n.language || "sk";

  if (!counters) {
    return (
      <p className="text-xs sm:text-sm text-muted-foreground">
        <span className="font-semibold text-foreground">50+</span> {t("pages.home.hero.trustIndicator")}
      </p>
    );
  }

  return (
    <p className="text-xs sm:text-sm text-muted-foreground" data-testid="hero-platform-counters">
      <span className="font-semibold text-foreground">{formatCount(counters.organizations, lang)}+</span>{" "}
      {t("pages.home.hero.counters.firms")}
      <span aria-hidden="true"> · </span>
      <span className="font-semibold text-foreground">{formatCount(counters.users, lang)}+</span>{" "}
      {t("pages.home.hero.counters.users")}
    </p>
  );
};

export default HeroTrustLine;
